import { Action, createAction } from 'redux-act';

import TimestampPayload from '../TimestampPayload';
import ReservationPayload from './ReservationPayload';

export type CancelReservationPayload = ReservationPayload;
export const cancelReservation = createAction<CancelReservationPayload>('CANCEL_RESERVATION');
export type CancelReservationActionType = Action<CancelReservationPayload>;

export interface ReservationCanceledPayload extends TimestampPayload, ReservationPayload {}
export const reservationCanceled = createAction<ReservationCanceledPayload>('RESERVATION_CANCELED');

export interface ReservationCancelFailedPayload extends TimestampPayload, ReservationPayload {}
export const reservationCancelFailed = createAction<ReservationCancelFailedPayload>('RESERVATION_CANCEL_FAILED');
